import React, {useEffect, useState} from 'react'
import {useQuery} from '@apollo/client'
import {Button, Col, Form, Modal, Row, Card} from 'react-bootstrap'
import {GET_ONE_CONTACT_API} from '../../../gql/queries/contactsApiQueries'
import {IResOneContact, NodeContact} from '../../../types/contactsApi'
import {parseId} from '../../../helpers'
import moment from 'moment'
// import { DateInput } from '../../../components/DateInput'
import { formatPhoneDisplay } from 'utils/phoneUtils'
import { SignatureFormsEntriesTimeline } from '../../signatureFormsEntries/components/SignatureFormsEntriesTimeline'
import { GET_ALL_SIGNATURE_FORMS_ENTRIES_API } from '../../../gql/queries/signatureFormsEntriesApiQueries'
import { IResSignatureFormsEntriesAPI } from '../../../types/signatureFormsEntriesApi'

export const ModalPreview: React.FC<{
  idContact: string | null
  onClose: () => void
}> = ({idContact, onClose}) => {
  const [infoPreview, setInfoPreview] = useState<NodeContact | null>(null)

  const {data, loading, error} = useQuery<IResOneContact>(GET_ONE_CONTACT_API, {
    fetchPolicy: 'no-cache',
    variables: {id: parseId(idContact ?? '')},
    skip: !idContact,
  })

  const { data: dataEntries, loading: loadingEntries, refetch: refetchEntries } = useQuery<IResSignatureFormsEntriesAPI>(
    GET_ALL_SIGNATURE_FORMS_ENTRIES_API,
    {
      variables: { contact: parseId(idContact ?? '') } as any,
      fetchPolicy: 'network-only',
      skip: !idContact,
    }
  )

  useEffect(() => {
    if (data?.contactById) {
      setInfoPreview(data.contactById)
    }
  }, [data])

  if (!idContact || loading || error || !infoPreview) return null

  return (
    <Modal
      show={true}
      onHide={onClose}
      size='lg'
      backdrop='static'
      keyboard={false}
      dialogClassName='modal-wide-sm'
    >
      <Modal.Header closeButton>
        <Modal.Title>Contact Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: '#f2f3f8' }}>
        {/* Personal Information */}
        <Card>
          <Card.Title>
            <div className='kt-heading kt-heading--md custom-border-brand'>
              Personal Information
            </div>
          </Card.Title>
          <Card.Body>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Full Name</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.fullName || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Date of Birth</Form.Label>
                  <p className='text-dark mb-3'>
                    {infoPreview.dateBirth ? moment(infoPreview.dateBirth).format('MM/DD/YYYY') : 'N/A'}
                  </p>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Email</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.email || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Phone</Form.Label>
                  <p className='text-dark mb-3'>{formatPhoneDisplay(infoPreview.phone) || 'N/A'}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>First Name</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.firstName || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Middle Name</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.middleName || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Last Name</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.lastName || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Second Last Name</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.secondLastName || 'N/A'}</p>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Address Information */}
        <Card className='mt-4'>
          <Card.Title>
            <div className='kt-heading kt-heading--md custom-border-brand'>
              Address Information
            </div>
          </Card.Title>
          <Card.Body>
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Address 1</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.address1 || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Address 2</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.address2 || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>City</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.city || 'N/A'}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>State</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.stateEU?.name || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>Zip Code</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.zipCode || 'N/A'}</p>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className='fw-bold mb-1'>County FIPS</Form.Label>
                  <p className='text-dark mb-3'>{infoPreview.countyFips || 'N/A'}</p>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>


        {/* Signature Forms */}
        <Card className='mt-4'>
          <Card.Title>
            <div className='kt-heading kt-heading--md custom-border-brand'>
              Signature Forms
            </div>
          </Card.Title>
          <Card.Body>
            <SignatureFormsEntriesTimeline
              loading={loadingEntries}
              dataEntriesByLead={dataEntries?.allSignatureFormsEntries}
              refetch={refetchEntries}
              hasEmail={Boolean(infoPreview?.email && infoPreview.email.trim() !== '')}
              hasPhone={Boolean(infoPreview?.phone && infoPreview.phone.trim() !== '')}
              compact
            />
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
